import { IoMdArrowRoundBack, IoMdCheckmarkCircle } from "react-icons/io";
import NoPictureWarning from "../../resources/nopic.png";
import { useEffect, useRef, useState } from "react";
import { ajustedDate, getToday } from "../../utils/DateUtils";
import OrderService from "../../rest/orderService";
import ClientService from "../../rest/clientService";
import FinancialService from "../../rest/financialService";
import ProductService from "../../rest/productService";
import MenuService from "../../rest/menuService";
import ComboService from "../../rest/comboService";
import NotificationsService from "../../rest/notificationService";
import qs from "qs";

function KioskOrderReview({ cart, user, onBack, onFinish }) {
    const [loading, setLoading] = useState(false);
    const [clientInfo, setClientInfo] = useState();
    const [preferences, setPreferences] = useState();
    const [isOpened, setIsOpened] = useState(false);
    const receiptWinRef = useRef(null);
    const [itemCount, setItemCount] = useState(0);
    const clientCode = sessionStorage.getItem("clientCode");
    const [selectedPayment, setSelectedPayment] = useState(null);

    useEffect(() => {
        const info = JSON.parse(sessionStorage.getItem("clientInfo"));
        setClientInfo(info);

        const searchInput = getToday();

        const checkIfOpen = async () => {
            try {
                const data = await FinancialService.checkIfOpen(searchInput);
                setIsOpened(data);
            } catch (error) {
                console.error(error);
                setIsOpened(false);
            }
        };

        const getPreferences = async () => {
            const data = await ClientService.getClientAdminPreferences();
            setPreferences(data);
        };

        checkIfOpen();
        getPreferences();
    }, [isOpened]);

    const cartArray = Object.values(cart || {});
    const total = cartArray.reduce(
        (acc, item) => acc + (item?.price || 0) * (item?.quantity || 0),
        0
    );

    const [order, setOrder] = useState({
        order_id: "",
        cashier_id: "",
        client_id: "",
        items_list: "",
        total: 0,
        received_value: "",
        status: "",
        sale_point: "",
        client_code: "",
        transactions: [],
    });

    const [transaction, setTransaction] = useState([
        {
            paymentMethod: "",
            value: 0.0,
            change: 0,
            received_value: 0.0,
            input: "",
            client_code: clientCode,
            customer_id: "",
            transactionDate: ajustedDate(),
            transaction_type: "Order",
        },
    ]);

    const generateItemList = (products) => {
        const productArray = Array.isArray(products)
            ? products
            : Object.values(products);
        return productArray
            .map(
                (product) =>
                    `${product.id} x${product.name} x${product.quantity} x${product.type} x${product.price} x${product.client_code}`
            )
            .join(", ");
    };

    useEffect(() => {
        if (!user || !cart) return;

        const totalAmount = Object.values(cart).reduce(
            (acc, item) => acc + (item?.price || 0) * (item?.quantity || 0),
            0
        );

        const updatedTransaction = [
            {
                ...transaction[0],
                paymentMethod: user.login === "anonymous" ? "" : "CREDITO FOODZ",
                value: totalAmount,
                received_value: totalAmount,
                customer_id: user.login,
            },
        ];
        setTransaction(updatedTransaction);

        setOrder((prevOrder) => ({
            ...prevOrder,
            order_id: prevOrder.order_id || Math.floor(Math.random() * 999999999),
            cashier_id: sessionStorage.getItem("name") || "unknown",
            client_id: `${user.login} / ${user.name}`,
            purchase_date: ajustedDate(),
            items_list: generateItemList(cart),
            total: totalAmount,
            status: "COMPLETED",
            sale_point: "TOTEM",
            client_code: clientCode || "",
            last_update: ajustedDate(),
            transactions: updatedTransaction,
        }));

        const searchInput = getToday();
        const checkIfOpen = async () => {
            try {
                const data = await FinancialService.checkIfOpen(searchInput);
                setIsOpened(data);
            } catch (error) {
                console.error(error);
                setIsOpened(false);
            }
        };

        const getPreferences = async () => {
            const data = await ClientService.getClientAdminPreferences();
            setPreferences(data);
        };

        checkIfOpen();
        getPreferences();
    }, [user, cart]);

    async function updateProductData() {
        try {
            for (const s of Object.values(cart)) {
                if (s.type === "product") {
                    await ProductService.updateProductQuantity(s.id, "REMOVE", {
                        product_id: s.id,
                        quantity: s.quantity,
                        clientCode: s.client_code,
                    });
                } else if (s.type === "recipe") {
                    await MenuService.updateRecipeQuantity(s.id, "REMOVE", {
                        recipe_id: s.id,
                        quantity: s.quantity,
                        clientCode: s.client_code,
                    });
                } else if (s.type === "combo") {
                    await ComboService.updateComboQuantity(s.id, "REMOVE", {
                        combo_id: s.id,
                        quantity: s.quantity,
                        client_code: s.client_code,
                    });
                }
            }
            return true;
        } catch (error) {
            console.error("Erro ao atualizar produtos:", error);
            return false;
        }
    }

    async function notifyPurchase() {
        const send = preferences?.enable_send_notifications === true;

        if (send) {
            const cartArray = Array.isArray(cart) ? cart : Object.values(cart || {});

            NotificationsService.sendEmailNotificationForOrder(
                clientInfo,
                user,
                order,
                "Totem",
                0,
                cartArray
            )
                .then(() => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response && error.response.status === 400) {
                        setTimeout(() => {
                            onFinish();
                        }, 1000);
                    }
                });
        } else {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }

    useEffect(() => {
        setItemCount(Object.values(cart).reduce((acc, p) => acc + p.quantity, 0));
    }, [cart]);

    const handleClickFinalize = (win) => {
        const totalAmount = Object.values(cart).reduce(
            (acc, item) => acc + (item?.price || 0) * (item?.quantity || 0),
            0
        );

        const queryString = qs.stringify({
            customer: JSON.stringify(user.name),
            orderId: order.order_id,
            selectedProducts: JSON.stringify(cart),
            currentCredit: JSON.stringify(user.credit),
            grade:
                user.role === "STUDENT"
                    ? JSON.stringify(user.grade)
                    : JSON.stringify("COLABORADOR"),
            transactions: order.transactions,
            itemCount,
            totalAmount: JSON.stringify(totalAmount),
            change: 0,
            totalReceived: JSON.stringify(totalAmount),
            operator: "TOTEM AUTOATENDIMENTO",
            clientInfo: JSON.stringify(clientInfo),
            print: true,
            auto_print: preferences.enable_auto_print,
        });

        let popup =
            win ||
            window.open(
                "",
                "_blank",
                "toolbar=no,location=no,width=340,height=600"
            );
        if (!popup) {
            alert("Não foi possível abrir a janela. Verifique se o popup está bloqueado.");
            return;
        }

        try {
            if (popup.closed) {
                const reopened = window.open(
                    `/comprovante?${queryString}`,
                    "_blank",
                    "toolbar=no,location=no,width=340,height=600"
                );
                if (!reopened) {
                    alert("Não foi possível abrir a janela. Verifique se o popup está bloqueado.");
                } else {
                    try {
                        reopened.focus();
                    } catch (e) { }
                }
            } else {
                popup.location.href = `/comprovante?${queryString}`;
                try {
                    popup.focus();
                } catch (e) { }
            }
        } catch (err) {
            console.error("Erro ao finalizar popup:", err);
            alert("Não foi possível abrir a janela do comprovante. Verifique se o popup está bloqueado.");
        } finally {
            receiptWinRef.current = null;
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            if (user.login === "anonymous") {
                if (!selectedPayment) {
                    alert("Selecione uma forma de pagamento antes de finalizar.");
                    setLoading(false);
                    return;
                }

                const updatedOrder = {
                    ...order,
                    transactions: [
                        {
                            ...transaction[0],
                            paymentMethod: selectedPayment,
                            value: total,
                            received_value: total,
                        },
                    ],
                };

                const resp = await OrderService.registerOrder({ order: updatedOrder });
                if (resp && (resp.status === 201 || resp.status === 200)) {
                    const savedOrder = resp.data?.order || {};
                    if (savedOrder.order_id) {
                        setOrder((prev) => ({ ...prev, order_id: savedOrder.order_id }));
                    }
                    setTimeout(() => {
                        onFinish();
                    }, 1000);
                }
                return;
            }

            const resp = await OrderService.registerOrder({ order });
            if (resp && (resp.status === 201 || resp.status === 200)) {
                const savedOrder = resp.data?.order || {};
                if (savedOrder.order_id) {
                    setOrder((prev) => ({ ...prev, order_id: savedOrder.order_id }));
                }

                const updateSuccess = await updateProductData();
                if (updateSuccess) {
                    handleClickFinalize(receiptWinRef.current);
                    notifyPurchase();
                }
            }
        } catch (error) {
            console.error("🚨 Erro ao enviar pedido:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-full w-full flex flex-col bg-gray-50">
            {/* Cabeçalho */}
            <div className="flex items-center justify-between p-4 bg-custom_blue text-white shadow-lg">
                <button
                    onClick={onBack}
                    className="flex items-center gap-2 text-lg font-semibold"
                >
                    <IoMdArrowRoundBack size={24} />
                    Voltar
                </button>
                <h1 className="text-2xl font-bold">Revisão do Pedido</h1>
                <div className="flex items-center gap-2 text-lg font-semibold">
                    Total: R$ {total.toFixed(2)}
                </div>
            </div>

            {/* Header do usuário (esconde se for anônimo) */}
            {user?.login !== "anonymous" && (
                <div className="p-6 bg-white shadow-md flex items-center gap-4">
                    <img
                        src={user?.imageData || user?.image || NoPictureWarning}
                        alt={user?.name}
                        className="w-16 h-16 rounded-full object-cover shadow-md"
                    />
                    <div className="w-full">
                        <div className="w-full flex px-4 items-center justify-between">
                            <div>
                                <h2 className="text-xl font-bold">
                                    {user?.name} ({user?.login})
                                </h2>
                            </div>
                            <p className="text-gray-600">{user?.grade}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Lista do pedido e pagamento */}
            <div className="flex-1 overflow-y-auto p-6 space-y-4">
                {cartArray.map((item, i) => (
                    <div
                        key={i}
                        className="flex justify-between items-center bg-white p-4 rounded-lg shadow-md"
                    >
                        <div className="flex items-center gap-3">
                            <img
                                src={item.imageData || item.image || NoPictureWarning}
                                alt={item.name}
                                className="w-12 h-12 object-cover rounded-lg"
                            />
                            <span className="font-semibold">{item.name}</span>
                        </div>
                        <span className="text-custom_green font-bold">
                            Quantidade: {item.quantity}
                        </span>
                        <span className="text-custom_green font-bold">
                            R$ {item.price.toFixed(2)}
                        </span>
                    </div>
                ))}
            </div>

            {/* Pagamento e finalizar - fixados */}
            <div className="bg-white border-t border-gray-200 p-6">
                {user?.login === "anonymous" && (
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold mb-3 text-gray-700">
                            Escolha a forma de pagamento:
                        </h3>
                        <div className="grid grid-cols-2 gap-3">
                            {[
                                "Dinheiro",
                                "PIX",
                                "VA | VR",
                                "Cartão (Crédito)",
                                "Cartão (Débito)",
                            ].map((method) => (
                                <button
                                    key={method}
                                    onClick={() => setSelectedPayment(method)}
                                    className={`py-4 rounded-xl text-lg font-bold transition-all border-2 ${selectedPayment === method
                                            ? "bg-custom_green text-white border-custom_green"
                                            : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                                        }`}
                                >
                                    {method}
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                <button
                    onClick={handleSubmit}
                    disabled={loading || (user.login === "anonymous" && !selectedPayment)}
                    className={`w-full py-4 text-white text-2xl font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 transition-transform ${loading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-custom_green hover:scale-105 active:scale-95"
                        }`}
                >
                    <IoMdCheckmarkCircle size={28} />
                    {loading ? "Processando..." : "Finalizar Pedido"}
                </button>
            </div>
        </div>
    );
}

export default KioskOrderReview;
